import type { Block } from '@/entities/chat-message';
import { InsightsGroup, type InsightGroup } from './InsightsGroup';

function groupInsightBlocks(blocks: Block[]): InsightGroup[] {
  const groups: InsightGroup[] = [];
  let current: InsightGroup | null = null;

  for (const block of blocks) {
    if (block.type === 'text') {
      current = { heading: block, cards: [] };
      groups.push(current);
    } else {
      if (!current) {
        current = { heading: null, cards: [] };
        groups.push(current);
      }
      current.cards.push(block);
    }
  }

  return groups.filter((g) => g.heading !== null || g.cards.length > 0);
}

interface InsightsPanelProps {
  insights: Block[];
}

export function InsightsPanel({ insights }: InsightsPanelProps) {
  const groups = groupInsightBlocks(insights);

  if (groups.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      <div>
        <p className="text-xs font-medium tracking-wide text-gray-400 uppercase">
          What's going into your plan
        </p>
        <hr className="mt-2 border-gray-200" />
      </div>
      <div className="relative flex flex-col gap-5">
        <div className="absolute top-1 bottom-1 left-[10px] w-px bg-gray-200" />
        {groups.map((group, groupIdx) => {
          const groupKey =
            group.heading?.key ??
            group.heading?.data ??
            group.cards.at(0)?.key ??
            groupIdx;
          return <InsightsGroup key={groupKey} group={group} />;
        })}
      </div>
    </div>
  );
}
